import { useEffect, useState } from "react";
import { Option } from "react-bootstrap-typeahead/types/types";
import { useMsal } from "@azure/msal-react";
import Autocomplete from "../../../components/Autocomplete";
import { StyledSubTitle } from "../../../styles/MainStyles";
import S from "../../../styles/pages/HistoryTach";
import { useTachHistory } from "../../../context/TachContext/TachHistoryContext";
import GenericUtils from "../../../utils/GenericUtils";
import { getAllTeachers } from "../../../service/Docente/HistoryTachService";
import {
    getCurrentUserFromOptions,
    transformTeacherToOption,
} from "../../../utils/TachUtils";
import { ChoosePeriodModal } from "../ChoosePeriodModal";
import ButtonStyles from "../../../styles/components/ButtonStyles";

const { BtnOutlinePrimary } = ButtonStyles;

const SelectTeacherContainer: React.FC = () => {
    const { instance } = useMsal();
    const {
        teachers,
        setYears,
        setYearValue,
        setDateRange,
        selectedTeacher,
        setSelectedTeacher,
        setTeachers,
        documents,
        setDocuments,
        getTachDocuments,
        handleAutoCompleteChange,
    } = useTachHistory();
    const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);
    const [choosePeriodModalOpen, setChoosePeriodModalOpen] =
        useState<boolean>(false);
    const loggedTeacher = GenericUtils.getUser();
    const canEdit =
        loggedTeacher !== null
            ? loggedTeacher.isDac ||
              loggedTeacher.isCord ||
              loggedTeacher.isJuri
            : false;
    const doesNotHaveToSearchForDocs =
        loggedTeacher !== null &&
        (loggedTeacher.isDac || loggedTeacher.isCord) &&
        !loggedTeacher.isDocente;

    const getInitialSelectData = async () => {
        if (canEdit) {
            const response = await getAllTeachers(instance);

            if (GenericUtils.isSuccessStatus(response)) {
                const responseTeacher =
                    response.status === 200
                        ? response.data
                        : response.data._result;

                const transformedTeachers: Option[] = transformTeacherToOption([
                    ...responseTeacher,
                ]);

                setTeachers(transformedTeachers);
                const initialTeacher = getCurrentUserFromOptions(
                    loggedTeacher.idUsuario,
                    responseTeacher
                );

                setSelectedTeacher(initialTeacher);

                if (!doesNotHaveToSearchForDocs) {
                    getTachDocuments({ teacherId: loggedTeacher.idUsuario });
                }
            }
            return;
        }

        const transformedTeachers = transformTeacherToOption([loggedTeacher]);
        setTeachers(transformedTeachers);
        setSelectedTeacher(transformedTeachers);
        getTachDocuments({ teacherId: loggedTeacher.idUsuario });
    };

    const handleDownloadClick = () => {
        setChoosePeriodModalOpen(true);
    };

    useEffect(() => {
        getInitialSelectData();
    }, []);

    const handleSelectTeacher = (selected: Option[]) => {
        if (canEdit) {
            setDocuments([]);
        }
        setYearValue([]);
        setDateRange([new Date(), new Date()]);
        setIsButtonDisabled(false);
        handleAutoCompleteChange(selected, canEdit);
        if (selected.length !== 0) {
            const filteredData = {
                teacherId: (selected[0] as any).value,
            };
            getTachDocuments(filteredData);
        }
    };

    const handleAutoCompleteClearButtonClicked = () => {
        if (canEdit) {
            setSelectedTeacher([]);
            setDocuments([]);
        }
        setYears([]);
        setIsButtonDisabled(true);
    };

    return (
        <S.SelectTeacherContainer>
            <S.SelectTeacher>
                <StyledSubTitle>
                    Selecione o nome do(a) professor(a)
                </StyledSubTitle>
                <Autocomplete
                    style={S.SelectTeacherAutocompleteStyles}
                    onChange={handleSelectTeacher}
                    selected={selectedTeacher}
                    options={teachers}
                    placeholder="Selecionar professor"
                    customClearFunction={handleAutoCompleteClearButtonClicked}
                />
            </S.SelectTeacher>
            <BtnOutlinePrimary
                disabled={isButtonDisabled || documents.length === 0}
                onClick={() => handleDownloadClick()}
                style={{ marginTop: "53px", height: "48px" }}
            >
                Baixar documento(s)
            </BtnOutlinePrimary>
            {choosePeriodModalOpen && (
                <ChoosePeriodModal
                    openModal={choosePeriodModalOpen}
                    onHide={() => setChoosePeriodModalOpen(false)}
                />
            )}
        </S.SelectTeacherContainer>
    );
};

export { SelectTeacherContainer };
